import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ProvidedJobPostsSettingsUpdateRequest } from '../types/ProvidedJobPost';
import type AgentApiProvidedJobPostsShow from '@/types/serializers/AgentApiProvidedJobPostsShow';

export default function useUpdateProvidedJobPostSettings(id: number) {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async (data: ProvidedJobPostsSettingsUpdateRequest) => {
      const response = await fetch(`/agent/api/provided_job_posts/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || '更新に失敗しました');
      }

      const result: AgentApiProvidedJobPostsShow = await response.json();
      return result;
    },
    onSuccess: (data) => {
      // キャッシュを更新
      queryClient.setQueryData(['providedJobPost', id], data);
      queryClient.invalidateQueries({ queryKey: ['providedJobPost', id] });
    },
  });
}
